import { Box } from '@mui/material';
import {
  AgronodAlert,
  AgronodButton,
  AgronodDialog,
  AgronodTypography,
} from '@agronod/mui-components';

interface Props {
  open: boolean;
  antal: number;
  /** Gårdar som inte valts och låses pseudonymiserade. */
  ovriga: number;
  upptagen?: boolean;
  onClose: () => void;
  onBekrafta: () => void;
}

/**
 * Bekräftelse innan avpseudonymiseringen (kravspec v4 C.4): vad som händer
 * när urvalet låses permanent.
 */
export const BekraftaUrvalDialog = ({
  open,
  antal,
  ovriga,
  upptagen = false,
  onClose,
  onBekrafta,
}: Props) => (
  <AgronodDialog
    open={open}
    onClose={onClose}
    caption="Revisionsledare"
    title="Bekräfta urval för revision"
    maxWidth="sm"
    fullWidth
    actions={
      <>
        <AgronodButton variant="outlined" onClick={onClose}>
          Avbryt
        </AgronodButton>
        <AgronodButton variant="contained" disabled={upptagen} onClick={onBekrafta}>
          Bekräfta urval
        </AgronodButton>
      </>
    }
  >
    <AgronodTypography variant="body1" sx={{ mb: 1.5 }}>
      Du är på väg att välja ut{' '}
      <Box component="strong" sx={{ fontWeight: 600 }}>
        {antal} gårdar
      </Box>{' '}
      för revision på plats. När du bekräftar kommer:
    </AgronodTypography>
    <Box
      component="ul"
      sx={{
        m: 0,
        mb: 3,
        pl: 2.5,
        color: 'text.secondary',
        typography: 'body2',
        lineHeight: '22px',
        '& li + li': { mt: 0.5 },
      }}
    >
      <li>gårdarnas namn och organisationsnummer att visas</li>
      <li>övriga {ovriga} gårdar att låsas och inte längre kunna väljas</li>
    </Box>
    <AgronodAlert severity="info" title="Urvalet kan inte ändras här">
      Behöver du ändra urvalet i efterhand? Kontakta Agronod så hjälper vi
      dig. Åtgärden loggas.
    </AgronodAlert>
  </AgronodDialog>
);
